import React from "react";

interface PaginationProps {
  totalItems: number;
  rowsPerPage: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  windowSize?: number; // how many pages before/after current
}

export default function Pagination({
  totalItems,
  rowsPerPage,
  currentPage,
  onPageChange,
  windowSize = 1,
}: PaginationProps) {
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  if (totalPages <= 1) return null;

  const startPage = Math.max(1, currentPage - windowSize);
  const endPage = Math.min(totalPages, currentPage + windowSize);

  const pages: number[] = [];
  for (let p = startPage; p <= endPage; p++) {
    pages.push(p);
  }

  return (
    <div className="flex justify-center mt-4 space-x-2 items-center">
      {/* Jump to First */}
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(1)}
        className="px-3 py-1 border rounded disabled:opacity-40 hover:bg-gray-100"
      >
        {"<<"}
      </button>

      {/* Previous */}
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="px-3 py-1 border rounded disabled:opacity-40 hover:bg-gray-100"
      >
        {"<"}
      </button>

      {/* Sliding Page Window */}
      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`px-3 py-1 border rounded ${
            currentPage === page
              ? "bg-blue-500 text-white"
              : "bg-white hover:bg-gray-100"
          }`}
        >
          {page}
        </button>
      ))}

      {/* Next */}
      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="px-3 py-1 border rounded disabled:opacity-40 hover:bg-gray-100"
      >
        {">"}
      </button>

      {/* Jump to Last */}
      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(totalPages)}
        className="px-3 py-1 border rounded disabled:opacity-40 hover:bg-gray-100"
      >
        {">>"}
      </button>
    </div>
  );
}